<ul role="list">
    @for (filter of filters; track filter.id; let index = $index) {
        <li (focusout)="handleBlur($event)" data-cy="filter-option">
            <button
                #filterToggle
                type="button"
                class="sir-filter-toggle"
                data-cy="filter-toggle"
                [id]="getFilterToggleId(filter.id)"
                (click)="toggleDropdown(index)"
                (keydown)="onFilterToggleKeydown($event, index)"
                [attr.aria-expanded]="isFilterSelected(index)"
                [attr.aria-controls]="isFilterSelected(index) ? getDropdownId(index) : null"
                aria-haspopup="listbox">
                <span class="sir-text-style-button-m-default">{{ filter.name }}</span
                ><sirius-badge
                    data-cy="filter-badge"
                    [style.visibility]="filter.activeCount > 0 ? 'visible' : 'hidden'"
                    [ngClass]="{ 'sir-has-filter': filter.activeCount > 0 }"
                    [count]="filter.activeCount">
                </sirius-badge>
                <div class="sir-filter-icon">
                    @if (selectedFilter === index) {
                        <sirius-icon name="caret_up"></sirius-icon>
                    } @else {
                        <sirius-icon name="caret_down"></sirius-icon>
                    }
                </div>
            </button>
            @if (isFilterSelected(index)) {
                <sirius-filter-dropdown
                    data-cy="filter-dropdown"
                    [attr.id]="getDropdownId(index)"
                    [filterLabelId]="getFilterToggleId(filter.id)"
                    (click)="$event.stopPropagation()"
                    (selectionChange)="setFilterValues()"
                    (activatedFilters)="onFiltersActivated($event, filter.name, filter.id)"
                    (closeDropdown)="onDropdownClose(filterToggle)"
                    [values]="openFilterValues">
                </sirius-filter-dropdown>
            }
        </li>
    }
</ul>

@if (showAppliedChips) {
    <sirius-filter-applied-filter
        (deactivateAllFilters)="deactivateAllFilters()"
        (deactivateFilterValue)="deactivateFilterValue($event.filterId, $event.valueId)"
        [filters]="filters">
    </sirius-filter-applied-filter>
}
